<template lang="pug">
  
  v-menu(offset-y :nudge-top="-13")
    template(v-slot:activator="{ on }")
      div(style="cursor: pointer" v-on="on")
        v-avatar.mr-2(v-if="user.avatar" size="36px")
          img(:src="user.avatar")
        span.body-1.hidden-xs-only.hidden-sm-only {{ user.name }}
        v-icon arrow_drop_down
    v-list
      v-list-item(v-for="name, route in routes.user" :key="route" :to="route")
        v-list-item-title(v-text="name")

</template>

<script>
import { mapGetters } from 'vuex'

export default {

  data() {
    return {
      visible: false
    }
  },

  computed: {
    ...mapGetters('auth', {
      routes: 'routes',
      user: 'user',
    }),
  },
}
</script>